const OVERRIDE_LEFT_TREE = 'override-left-tree';

export { OVERRIDE_LEFT_TREE };
